<template>
  <div class="ranking-panel">
    <div class="ranking-container">
      <!-- 移动端警告提示（只在移动端显示） -->
      <div class="mobile-warning">
        <Icon type="ios-information-circle-outline" />
        提示：切换标签会自动查询，请勿频繁点击
      </div>

      <div class="layout-container">
        <!-- 左边栏：排行榜导航 -->
        <div class="sidebar">
          <div class="ranking-nav-heading"><span>排行榜</span><small>选择榜单</small></div>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'name5' }" @click="handleMenuSelect('name5')"><Icon type="ios-trophy" /><span class="menu-text">极品武器榜</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'name6' }" @click="handleMenuSelect('name6')"><Icon type="ios-paw" /><span class="menu-text">极品灵宠榜</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'lv' }" @click="handleMenuSelect('lv')"><Icon type="ios-trending-up" /><span class="menu-text">天榜</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'coin' }" @click="handleMenuSelect('coin')"><Icon type="ios-diamond" /><span class="menu-text">灵石榜</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'coin2' }" @click="handleMenuSelect('coin2')"><Icon type="ios-cash" /><span class="menu-text">金币榜</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'name1' }" @click="handleMenuSelect('name1')"><Icon type="ios-flame" /><span class="menu-text">世界 Boss（总）</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'name9' }" @click="handleMenuSelect('name9')"><Icon type="ios-flash" /><span class="menu-text">世界 Boss（单次）</span></button>
          <button type="button" class="menu-item" :class="{ active: activeTab === 'name8' }" @click="handleMenuSelect('name8')"><Icon type="ios-stats" /><span class="menu-text">爬塔层数榜</span></button>
        </div>

        <!-- 右边栏：排行榜内容 -->
        <div class="content-area">
          <div class="ranking-content-summary">
            <div>
              <span class="summary-kicker">当前榜单</span>
              <strong>{{ currentRankingLabel }}</strong>
            </div>
            <span class="summary-tip">数据按榜单规则实时更新</span>
            <Button size="small" type="primary" ghost icon="md-refresh" @click="leader" :loading="currentTabLoading">刷新</Button>
          </div>
          <!-- 极品武器排行榜 -->
          <div v-if="activeTab === 'name5'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">极品武器排行榜</h3>
              <div class="equip-filter">
                <div class="filter-section">
                  <div class="filter-label">装备类型：</div>
                  <RadioGroup v-model="equit" type="button" @on-change="equitList" button-style="solid" class="equip-radio-group">
                    <Radio label="1" class="radio-item">武器</Radio>
                    <Radio label="2" class="radio-item">玄端</Radio>
                    <Radio label="3" class="radio-item">头冠</Radio>
                    <Radio label="4" class="radio-item">项链</Radio>
                    <Radio label="7" class="radio-item">戒指</Radio>
                    <Radio label="8" class="radio-item">绶佩</Radio>
                    <Radio label="9" class="radio-item">绶带</Radio>
                    <Radio label="10" class="radio-item">鞜履</Radio>
                  </RadioGroup>
                </div>
                <div class="filter-section">
                  <div class="filter-label">装备等级：</div>
                  <Select v-model="equiltLevel" @on-change="equitList" class="level-select">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="heaven-list-wrap">
              <Spin v-if="loadingTabs.name5" fix>加载中...</Spin>
              <div v-else-if="pagedEquipData.length" class="heaven-list">
                <div v-for="(row, index) in pagedEquipData" :key="row.id || row.name || index" class="heaven-list-row collection-list-row">
                  <div class="heaven-avatar" :class="getRankingRankClass((equipPageNo - 1) * equipPageSize + index + 1)">{{ ((equipPageNo - 1) * equipPageSize + index + 1) }}</div>
                  <div class="heaven-main"><strong>{{ row.name || '未命名法器' }}</strong><span>Lv.{{ row.level || 0 }} · {{ row.roleName || '暂无所属道友' }}</span></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass((equipPageNo - 1) * equipPageSize + index + 1)">{{ getRankingTitle((equipPageNo - 1) * equipPageSize + index + 1) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>总分</small><strong>{{ row.total || 0 }}</strong></div>
                </div>
              </div>
              <div v-else class="heaven-list-state">暂无极品武器数据</div>
            </div>
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <Page
                :current="equipPageNo"
                :total="leaderboardLst5.length"
                :page-size="equipPageSize"
                size="small"
                simple
                @on-change="equipPageNo=$event"
                class="mobile-page"
              />
            </div>
          </div>

          <!-- 极品灵宠排行榜 -->
          <div v-if="activeTab === 'name6'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">极品灵宠排行榜</h3>
            </div>
            <div class="heaven-list-wrap">
              <Spin v-if="loadingTabs.name6" fix>加载中...</Spin>
              <div v-else-if="pagedPetData.length" class="heaven-list">
                <div v-for="(row, index) in pagedPetData" :key="row.id || row.name || index" class="heaven-list-row collection-list-row">
                  <div class="heaven-avatar" :class="getRankingRankClass((petPageNo - 1) * petPageSize + index + 1)">{{ ((petPageNo - 1) * petPageSize + index + 1) }}</div>
                  <div class="heaven-main"><strong>{{ row.name || '未命名灵宠' }}</strong><span>Lv.{{ row.level || 0 }} · {{ row.charName || '暂无所属道友' }}</span></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass((petPageNo - 1) * petPageSize + index + 1)">{{ getRankingTitle((petPageNo - 1) * petPageSize + index + 1) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>战力</small><strong>{{ fmtNumber(row.auraCombot || 0) }}</strong></div>
                </div>
              </div>
              <div v-else class="heaven-list-state">暂无极品灵宠数据</div>
            </div>
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <Page
                :current="petPageNo"
                :total="leaderboardLst9.length"
                :page-size="petPageSize"
                size="small"
                simple
                @on-change="petPageNo=$event"
                class="mobile-page"
              />
            </div>
          </div>

          <!-- 世界boss伤害榜(总) -->
          <div v-if="activeTab === 'name1'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">世界boss伤害榜(总)</h3>
            </div>
            <div v-for="(item, idx) in leaderboardLst7" :key="idx" class="boss-section">
              <div class="boss-title">
                <span class="boss-rank">{{ ++idx }}</span>
                <span class="boss-name">{{ item.name }}</span>
              </div>
              <div class="table-wrapper">
                <Table border highlight-row no-data-text="无数据" :loading="loadingTabs.name1"
                       :columns="mobileColumns2" :data="item.gameCharaLevelBoList" class="responsive-table">
                </Table>
              </div>
            </div>
          </div>

          <!-- 天榜 -->
          <div v-if="activeTab === 'lv'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">天榜</h3>
            </div>
            <div class="heaven-list-wrap">
              <Spin v-if="loadingTabs.lv" fix>加载中...</Spin>
              <div v-else-if="pagedHeavenData.length" class="heaven-list">
                <div
                  v-for="(row, index) in pagedHeavenData"
                  :key="row.id || row.charaId || row.name || index"
                  class="heaven-list-row"
                  :class="{ 'my-row': highlightMe(row) === 'my-row' }"
                >
                  <div class="heaven-avatar" :class="getRankingRankClass(row.rank || ((pageNo - 1) * pageSize + index + 1))">{{ row.rank || ((pageNo - 1) * pageSize + index + 1) }}</div>
                  <div class="heaven-main">
                    <strong>{{ row.name || '未知道友' }}</strong>
                    <span>{{ row.realmName || '未知境界' }} · {{ row.occupation || '道途未明' }}</span>
                  </div>
                  <div class="heaven-meta heaven-level"><small>等级</small><strong>Lv.{{ row.level || 0 }}</strong></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass(row.rank || ((pageNo - 1) * pageSize + index + 1))">{{ getRankingTitle(row.rank || ((pageNo - 1) * pageSize + index + 1)) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>天榜名次</small><strong>第 {{ row.rank || ((pageNo - 1) * pageSize + index + 1) }} 名</strong></div>
                </div>
              </div>
              <div v-else class="heaven-list-state">暂无天榜数据</div>
            </div>
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <Page
                :current="pageNo"
                :total="leaderboardLst4.length"
                :page-size="pageSize"
                size="small"
                simple
                @on-change="pageNo=$event"
                class="mobile-page"
              />
            </div>
          </div>

          <!-- 灵石榜 -->
          <div v-if="activeTab === 'coin'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">灵石榜</h3>
            </div>
            <div class="heaven-list-wrap">
              <Spin v-if="loadingTabs.coin" fix>加载中...</Spin>
              <div v-else-if="leaderboardLst1.length" class="heaven-list">
                <div v-for="(row, index) in leaderboardLst1" :key="row.id || row.name || index" class="heaven-list-row" :class="{ 'my-row': highlightMe(row) === 'my-row' }">
                  <div class="heaven-avatar" :class="getRankingRankClass(row.rank || index + 1)">{{ row.rank || index + 1 }}</div>
                  <div class="heaven-main"><strong>{{ row.name || '未知道友' }}</strong><span>灵石积累 · 排名数据</span></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass(row.rank || index + 1)">{{ getRankingTitle(row.rank || index + 1) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>灵石</small><strong>{{ fmtNumber(row.coin || 0) }}</strong></div>
                </div>
              </div>
              <div v-else class="heaven-list-state">暂无灵石榜数据</div>
            </div>
          </div>

          <!-- 金币榜 -->
          <div v-if="activeTab === 'coin2'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">金币榜</h3>
            </div>
            <div class="heaven-list-wrap">
              <Spin v-if="loadingTabs.coin2" fix>加载中...</Spin>
              <div v-else-if="leaderboardLst3.length" class="heaven-list">
                <div v-for="(row, index) in leaderboardLst3" :key="row.id || row.name || index" class="heaven-list-row" :class="{ 'my-row': highlightMe(row) === 'my-row' }">
                  <div class="heaven-avatar" :class="getRankingRankClass(row.rank || index + 1)">{{ row.rank || index + 1 }}</div>
                  <div class="heaven-main"><strong>{{ row.name || '未知道友' }}</strong><span>金币积累 · 排名数据</span></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass(row.rank || index + 1)">{{ getRankingTitle(row.rank || index + 1) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>金币</small><strong>{{ fmtNumber(row.money || 0) }}</strong></div>
                </div>
              </div>
              <div v-else class="heaven-list-state">暂无金币榜数据</div>
            </div>
          </div>

          <!-- 世界boss伤害榜(单次) -->
          <div v-if="activeTab === 'name9'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">世界boss伤害榜(单次)</h3>
            </div>
            <div v-for="(item, idx) in leaderboardLst6" :key="idx" class="boss-section">
              <div class="boss-title">
                <span class="boss-rank">{{ ++idx }}</span>
                <span class="boss-name">{{ item.name }}</span>
              </div>
              <div class="table-wrapper">
                <Table border highlight-row no-data-text="无数据" :loading="loadingTabs.name9"
                       :columns="mobileColumns3" :data="item.gameCharaLevelBoList" class="responsive-table">
                </Table>
              </div>
            </div>
          </div>

          <!-- 爬塔层数排行榜 -->
          <div v-if="activeTab === 'name8'" class="ranking-content">
            <div class="content-header">
              <h3 class="content-title">爬塔层数排行榜</h3>
            </div>
            <div v-if="normalizedTowerRankings.length" class="heaven-list-wrap">
              <div class="heaven-list">
                <div v-for="(item, idx) in normalizedTowerRankings" :key="idx" class="heaven-list-row">
                  <div class="heaven-avatar" :class="getRankingRankClass(idx + 1)">{{ idx + 1 }}</div>
                  <div class="heaven-main"><strong>{{ item.name || item.roleName || item.charName || '未知角色' }}</strong><span>{{ item.roleName || item.charName || '暂无所属道友' }} · 爬塔挑战</span></div>
                  <div class="heaven-meta heaven-title"><small>榜单称号</small><span class="ranking-title-badge" :class="getRankingTitleClass(idx + 1)">{{ getRankingTitle(idx + 1) }}</span></div>
                  <div class="heaven-meta heaven-rank"><small>最高层数</small><strong>{{ item.towerLabel }}</strong></div>
                </div>
              </div>
            </div>
            <div v-else class="empty-ranking">暂无爬塔排行榜数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rankingList",
  data() {
    return {
      activeTab: 'name5', // 默认激活的标签
      pageNo: 1,
      pageSize: 10,
      // 添加极品武器的分页参数
      equipPageNo: 1,
      equipPageSize: 10,
      // 添加灵宠的分页参数
      petPageNo: 1,
      petPageSize: 10,
      equit: 1,
      equiltLevel: 70,
      leaderboardLst1: [], // 灵石排行榜列表
      leaderboardLst2: [], // 等级排行榜列表
      leaderboardLst3: [], // 金币排行榜列表
      leaderboardLst4: [], // 天榜排行榜列表
      leaderboardLst5: [], // 极品武器排行榜
      leaderboardLst6: [], // 世界boss伤害(单次)排行榜列表
      leaderboardLst7: [], // 世界boss伤害(总)排行榜列表
      leaderboardLst8: [], // 爬塔层数排行榜
      leaderboardLst9: [], // 极品灵宠排行榜
      loadingTabs: {
        name5: false,
        name6: false,
        name1: false,
        lv: false,
        coin: false,
        coin2: false,
        name9: false,
        name8: false
      },
      loadedTabs: {
        name5: false,
        name6: false,
        name1: false,
        lv: false,
        coin: false,
        coin2: false,
        name9: false,
        name8: false
      },
      cityList: [
        { value: '70', label: '70' },
        { value: '65', label: '65' },
        { value: '60', label: '60' },
        { value: '55', label: '55' },
        { value: '50', label: '50' },
        { value: '45', label: '45' },
        { value: '40', label: '40' },
        { value: '30', label: '30' },
        { value: '23', label: '23传说' },
        { value: '21', label: '21' }
      ],
    };
  },
  computed: {
    currentTabLoading() {
      return this.loadingTabs[this.activeTab];
    },
    currentRankingLabel() {
      const labels = {
        name1: '世界 Boss（总伤害）',
        name9: '世界 Boss（单次伤害）',
        name8: '爬塔层数',
        lv: '天榜',
        coin: '灵石榜',
        coin2: '金币榜',
        name5: '极品武器',
        name6: '极品灵宠'
      };
      return labels[this.activeTab] || '排行榜';
    },
    // 极品武器分页数据
    pagedEquipData() {
      const start = (this.equipPageNo - 1) * this.equipPageSize;
      const end = start + this.equipPageSize;
      return this.leaderboardLst5.slice(start, end);
    },

    // 灵宠分页数据
    pagedPetData() {
      const start = (this.petPageNo - 1) * this.petPageSize;
      const end = start + this.petPageSize;
      return this.leaderboardLst9.slice(start, end);
    },
    pagedData() {
      const start = (this.pageNo - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.leaderboardLst2.slice(start, end);
    },
    pagedHeavenData() {
      const start = (this.pageNo - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.leaderboardLst4.slice(start, end);
    },
    normalizedTowerRankings() {
      return this.leaderboardLst8.map((item) => ({
        ...item,
        towerLabel: this.formatTowerLevel(item)
      }));
    },
    mobileColumns7() {
      const isMobile = this.isMobile();
      return [
        {
          title: '排名',
          key: 'rank',
          width: isMobile ? 50 : 70,
          align: 'center',
          render: (h, { row }) => h('span', {
            class: 'rank-cell',
            style: {
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, row.rank)
        },
        {
          title: '角色',
          key: 'name',
          align: 'left',
          render: (h, { row }) => {
            let color="default";
            if(row.rank<4){
              color= "error";
            }else if(row.rank<11){
              color= "warning";
            }else if(row.rank<26){
              color= "primary";
            }else if(row.rank<51){
              color= "success";
            }
            return h('div', { class: 'name-cell' }, [
              h('span', {
                class: 'name-text',
                style: {
                  marginRight: '6px',
                  fontSize: isMobile ? '12px' : '14px'
                }
              }, row.name),
              row.title ? h('Tag', {
                props: {
                  color: color,
                  size: isMobile ? 'small' : 'default'
                },
                class: 'title-tag'
              }, row.title) : null
            ])
          }
        },
        {
          title: '灵石',
          key: 'coin',
          width: isMobile ? 80 : 100,
          align: 'right',
          render: (h, { row }) => h('span', {
            class: 'coin-cell',
            style: {
              color: '#342b2b',
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, this.fmtNumber(row.coin))
        }
      ];
    },
    mobileColumns8() {
      const isMobile = this.isMobile();
      return [
        {
          title: '排名',
          key: 'rank',
          width: isMobile ? 50 : 70,
          align: 'center',
          render: (h, { row }) => h('span', {
            class: 'rank-cell',
            style: {
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, row.rank)
        },
        {
          title: '角色',
          key: 'name',
          align: 'left',
          render: (h, { row }) => {
            let color="default";
            if(row.rank<4){
              color= "error";
            }else if(row.rank<11){
              color= "warning";
            }else if(row.rank<26){
              color= "primary";
            }else if(row.rank<51){
              color= "success";
            }
            return h('div', { class: 'name-cell' }, [
              h('span', {
                class: 'name-text',
                style: {
                  marginRight: '6px',
                  fontSize: isMobile ? '12px' : '14px'
                }
              }, row.name),
              row.title ? h('Tag', {
                props: {
                  color: color,
                  size: isMobile ? 'small' : 'default'
                },
                class: 'title-tag'
              }, row.title) : null
            ])
          }
        },
        {
          title: '金币',
          key: 'money',
          width: isMobile ? 80 : 100,
          align: 'right',
          render: (h, { row }) => h('span', {
            class: 'money-cell',
            style: {
              color: '#ed4014',
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, this.fmtNumber(row.money))
        }
      ];
    },
    mobileColumns2() {
      const isMobile = this.isMobile();
      return [
        {
          title: '总伤害',
          key: 'totalDamage',
          align: 'center',
          render: (h, params) => h('span', {
            class: 'damage-cell',
            style: { fontSize: isMobile ? '12px' : '14px' }
          }, this.fmtNumber(params.row.totalDamage))
        },
        {
          title: '玩家',
          key: 'name',
          align: 'center',
          render: (h, params) => {
            let name = params.row.name;
            let color = "green";
            if(params.index < 3){
              color = "red";
            }else if(params.index < 10){
              color = "#ff8c00";
            }else if(params.index < 25){
              color = "purple";
            }else if(params.index < 50){
              color = "blue";
            }
            return h('div', { class: 'player-cell' }, [
              h('span', {
                style: {
                  color: color,
                  fontSize: isMobile ? '12px' : '14px',
                  fontWeight: 'bold'
                }
              }, this.truncateText(name, isMobile ? 3 : 6)),
            ]);
          }
        },
        {
          title: '境界',
          key: 'realmName',
          align: 'center',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '11px' : '13px' }
          }, this.truncateText(params.row.realmName, isMobile ? 2 : 4))
        }
      ];
    },
    mobileColumns3() {
      const isMobile = this.isMobile();
      return [
        {
          title: '单次伤害',
          key: 'oneDamage',
          align: 'center',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '12px' : '14px' }
          }, this.fmtNumber(params.row.oneDamage))
        },
        {
          title: '玩家',
          key: 'name',
          align: 'center',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '12px' : '14px' }
          }, this.truncateText(params.row.name, isMobile ? 3 : 6))
        },
        {
          title: '境界',
          key: 'realmName',
          align: 'center',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '11px' : '13px' }
          }, this.truncateText(params.row.realmName, isMobile ? 2 : 4))
        }
      ];
    },
    mobileColumns() {
      const isMobile = this.isMobile();
      return [
        {
          title: '法器',
          key: 'name',
          render: (h, params) => {
            // 计算全局排名 = (当前页码-1) * 每页数量 + 当前索引
            const globalRank = (this.equipPageNo - 1) * this.equipPageSize + params.index;
            let name = params.row.name;
            let color = "success";
            if(globalRank < 3){
              color = "error";
            }else if(globalRank < 10){
              color = "warning";
            }else if(globalRank < 30){
              color = "primary";
            }
            return h('div', { class: 'equip-cell' }, [
              h('Tag', {
                props: {
                  color: color,
                  type: "border",
                  size: isMobile ? 'small' : 'default'
                },
                class: 'level-tag'
              }, "Lv:" + params.row.level),
              h('Tag', {
                props: {
                  color: color,
                  size: isMobile ? 'small' : 'default'
                },
                class: 'name-tag'
              }, this.truncateText(name, isMobile ? 4 : 8)),
            ]);
          }
        },
        {
          title: '所属人',
          key: 'roleName',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '12px' : '14px' }
          }, this.truncateText(params.row.roleName, isMobile ? 3 : 6))
        },
        {
          title: '总分',
          key: 'total',
          align: 'center',
          render: (h, params) => h('span', {
            style: {
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, params.row.total)
        }
      ];
    },
    mobileColumnsZhen() {
      const isMobile = this.isMobile();
      return [
        {
          title: '灵宠',
          key: 'name',
          render: (h, params) => {
            // 计算全局排名 = (当前页码-1) * 每页数量 + 当前索引
            const globalRank = (this.petPageNo - 1) * this.petPageSize + params.index;
            let name = params.row.name;
            let color = "success";
            if(globalRank < 3){
              color = "error";
            }else if(globalRank < 10){
              color = "warning";
            }else if(globalRank < 30){
              color = "primary";
            }
            return h('div', { class: 'pet-cell' }, [
              h('Tag', {
                props: {
                  color: color,
                  type: "border",
                  size: isMobile ? 'small' : 'default'
                },
                class: 'level-tag'
              }, "Lv:" + params.row.level),
              h('Tag', {
                props: {
                  color: color,
                  size: isMobile ? 'small' : 'default'
                },
                class: 'name-tag'
              }, this.truncateText(name, isMobile ? 4 : 8)),
            ]);
          }
        },
        {
          title: '战力',
          key: 'auraCombot',
          align: 'center',
          render: (h, params) => h('span', {
            style: {
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '14px'
            }
          }, this.fmtNumber(params.row.auraCombot))
        },
        {
          title: '所属人',
          key: 'charName',
          render: (h, params) => h('span', {
            style: { fontSize: isMobile ? '12px' : '14px' }
          }, this.truncateText(params.row.charName, isMobile ? 3 : 6))
        }
      ];
    }
  },
  created() {
    this.loadRankingByTab(this.activeTab);
  },
  methods: {
    // 处理菜单选择
    handleMenuSelect(name) {
      this.activeTab = name;
      // 切换标签时重置分页
      if (name === 'name5') {
        this.equipPageNo = 1;
      } else if (name === 'name6') {
        this.petPageNo = 1;
      } else if (name === 'lv') {
        this.pageNo = 1;
      }
      this.loadRankingByTab(name);
    },

    isMobile() {
      if (this.$store && this.$store.state && this.$store.state.responsive) {
        return !!this.$store.state.responsive.isMobile;
      }
      return window.innerWidth <= 768;
    },
    truncateText(text, length) {
      if (!text) return '';
      if (this.isMobile() && text.length > length) {
        return text.substring(0, length) + '...';
      }
      return text;
    },
    fmtNumber(num) {
      if (!num) return '0';
      if (num >= 100000000) return (num / 100000000).toFixed(2) + '亿';
      if (num >= 10000) return (num / 10000).toFixed(1) + '万';
      if (num >= 1000) return (num / 1000).toFixed(1) + '千';
      return num.toString();
    },
    getResponseList(res) {
      return Array.isArray(res && res.data && res.data.data) ? res.data.data : [];
    },
    fetchRanking(url, key, mapper) {
      return this.$http.get(url).then((res) => {
        const list = this.getResponseList(res);
        this[key] = typeof mapper === 'function' ? list.map(mapper) : list;
        return this[key];
      }).catch(() => {
        this[key] = [];
        return [];
      });
    },
    loadRankingByTab(tab, options = {}) {
      const { force = false } = options;
      const withRankTitle = (item, idx) => ({
        ...item,
        rank: idx + 1,
        title: this.getTitle(idx + 1)
      });

      const requestMap = {
        coin: () => this.fetchRanking("/gamepassport/coinRanking", "leaderboardLst1", withRankTitle),
        lv: () => this.fetchRanking("/gamepassport/realmHeavenList", "leaderboardLst4", withRankTitle),
        coin2: () => this.fetchRanking("/gamepassport/moneyRanking", "leaderboardLst3", withRankTitle),
        name5: () => this.fetchRanking("/gamepassport/realmLandList?equitType=" + this.equit + "&level=" + this.equiltLevel, "leaderboardLst5"),
        name9: () => this.fetchRanking("/gamepassport/oneDamageRanking", "leaderboardLst6"),
        name1: () => this.fetchRanking("/gamepassport/totalDamageRanking", "leaderboardLst7"),
        name8: () => this.fetchRanking("/gamepassport/totwerNumList", "leaderboardLst8"),
        name6: () => this.fetchRanking("/gamepassport/toPetList", "leaderboardLst9")
      };

      const request = requestMap[tab];
      if (!request) return Promise.resolve([]);
      if (this.loadingTabs[tab]) return Promise.resolve([]);
      if (!force && this.loadedTabs[tab]) return Promise.resolve([]);

      this.loadingTabs[tab] = true;
      return request().then((list) => {
        this.loadedTabs[tab] = true;
        return list;
      }).finally(() => {
        this.loadingTabs[tab] = false;
      });
    },
    formatTowerLevel(item) {
      const towerValue =
        item.lockTowerName ||
        item.towerName ||
        item.lockTowerNum ||
        item.totwerNum ||
        item.towerNum ||
        item.layer ||
        item.level;

      if (towerValue === undefined || towerValue === null || towerValue === '') {
        return '暂无层数';
      }

      if (typeof towerValue === 'number' || /^\d+$/.test(String(towerValue))) {
        return `第${towerValue}层`;
      }

      return towerValue;
    },
    // 列表
    leader() {
      return this.loadRankingByTab(this.activeTab, { force: true });
    },
    getTitle(rank) {
      if (rank === 1) return '冠绝古今';
      if (rank === 2) return '威震天下';
      if (rank === 3) return '威震天下';
      if (rank <= 10) return '声名远扬';
      if (rank <= 25) return '初露锋芒';
      if (rank <= 50) return '崭露头角';
      return '榜上有名';
    },
    getRankingTitle(rank) {
      return this.getTitle(Number(rank) || 0);
    },
    getRankingTitleClass(rank) {
      const value = Number(rank) || 0;
      if (value === 1) return 'ranking-title--first';
      if (value <= 3) return 'ranking-title--top3';
      if (value <= 10) return 'ranking-title--top10';
      return 'ranking-title--normal';
    },
    getRankingRankClass(rank) {
      return 'ranking-rank--normal';
    },
    highlightMe(row) {
      return row.name === 1001 ? 'my-row' : '';
    },
    equitList() {
      this.equipPageNo = 1;
      this.loadedTabs.name5 = false;
      this.loadRankingByTab('name5', { force: true });
    }
  },
};
</script>

<style scoped>
/* 基础样式 */
.card-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.card-extra {
  display: flex;
  align-items: center;
}

.ranking-container {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 220px);
  min-height: 0;
}

/* 移动端警告提示 */
.mobile-warning {
  display: none;
  padding: 8px 12px;
  background: #f0f9ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #096dd9;
}

/* 主布局容器 */
.layout-container {
  display: flex;
  flex: 1;
  min-height: 0;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 左边栏样式 */
.sidebar {
  width: 25%;
  min-width: 200px;
  background: #f8f8f9;
  border-right: 1px solid #e8eaec;
  overflow-y: auto;
}

.menu-item {
  padding: 14px 16px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  border-left: 3px solid transparent;
}

.menu-item:hover {
  background-color: #f0f0f0;
}

.menu-item.ivu-menu-item-active {
  background-color: #e6f7ff;
  border-left-color: #1890ff;
  color: #1890ff;
}

.menu-item i {
  margin-right: 10px;
  font-size: 18px;
  min-width: 24px;
  text-align: center;
}

.menu-text {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 右边内容区样式 */
.content-area {
  width: 75%;
  min-width: 0;
  padding: 20px;
  background: white;
  overflow-y: auto;
}

.ranking-content {
  min-height: 100%;
}

.content-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.content-title {
  font-size: 20px;
  font-weight: 600;
  color: #17233d;
  margin: 0 0 15px 0;
}

/* 装备筛选器 */
.equip-filter {
  background: #fafafa;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #e8eaec;
}

.filter-section {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.filter-section:last-child {
  margin-bottom: 0;
}

.filter-label {
  font-size: 14px;
  color: #515a6e;
  font-weight: 500;
  min-width: 80px;
  margin-right: 10px;
}

.equip-radio-group {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.radio-item {
  margin-right: 0 !important;
  flex: 1;
  min-width: 70px;
  text-align: center;
}

.level-select {
  width: 120px;
}

/* 表格包装器 */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.responsive-table {
  width: 100%;
}

/* Boss 排名样式 */
.boss-section {
  margin-bottom: 24px;
}

.boss-title {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
}

.boss-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #eef6fd;
  color: #6f8da6;
  border: 1px solid #cfe3fb;
  border-radius: 4px;
  font-weight: bold;
  margin-right: 12px;
  font-size: 14px;
}

.boss-name {
  font-weight: 700;
  font-size: 16px;
  color: #333;
}

/* 爬塔列表样式 */
.tower-list {
  max-height: 424px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empty-ranking {
  text-align: center;
  color: #808695;
  padding: 48px 16px;
  background: #fafafa;
  border: 1px dashed #dcdee2;
  border-radius: 6px;
}

.tower-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s;
}

.tower-item:hover {
  background-color: #fafafa;
}

.tower-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  background: #f0f0f0;
  color: #666;
  border-radius: 4px;
  font-weight: bold;
  margin-right: 12px;
  font-size: 14px;
}

.tower-name {
  flex: 1;
  font-size: 14px;
  color: #333;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tower-level {
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
}

/* 分页样式 */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 16px 0;
  margin-top: 20px;
}

.mobile-page {
  transform: scale(0.9);
  transform-origin: center;
}

/* 单元格样式 */
.rank-cell {
  display: inline-block;
  min-width: 24px;
}

.name-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.name-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title-tag {
  flex-shrink: 0;
}

.level-tag, .name-tag {
  margin: 2px;
}

.damage-cell, .coin-cell, .money-cell {
  font-family: 'Arial', sans-serif;
}

.player-cell {
  text-align: center;
}

.equip-cell, .pet-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* 响应式设计 - 移动端 */
@media screen and (max-width: 768px) {
  .card-title {
    font-size: 16px;
  }

  .mobile-warning {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .mobile-warning i {
    margin-right: 6px;
    font-size: 16px;
  }

  /* 移动端改为垂直布局 */
  .layout-container {
    flex-direction: column;
    min-height: auto;
  }

  .ranking-container {
    max-height: none;
  }

  .sidebar {
    width: 100%;
    min-width: 100%;
    border-right: none;
    border-bottom: 1px solid #e8eaec;
    max-height: 200px;
    overflow-x: auto;
  }

  .content-area {
    width: 100%;
    padding: 15px;
  }

  .menu-item {
    padding: 12px 15px;
  }

  .menu-item i {
    font-size: 16px;
    margin-right: 8px;
  }

  .menu-text {
    font-size: 13px;
  }

  .content-title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .filter-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-label {
    margin-bottom: 8px;
    min-width: auto;
    width: 100%;
  }

  .equip-radio-group {
    width: 100%;
  }

  .level-select {
    width: 100%;
  }

  .boss-rank {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }

  .boss-name {
    font-size: 14px;
  }

  .tower-item {
    padding: 10px 8px;
  }

  .tower-rank {
    min-width: 24px;
    height: 24px;
    font-size: 12px;
    margin-right: 8px;
  }

  .tower-name,
  .tower-level {
    font-size: 13px;
  }

  .mobile-page {
    transform: scale(0.85);
  }

  /* 表格响应式优化 */
  .table-wrapper {
    margin: 0 -12px;
    padding: 0 12px;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /deep/ .ivu-table-wrapper {
    min-width: 100%;
  }

  /deep/ .ivu-table-cell {
    padding: 8px;
    white-space: nowrap;
  }

  /deep/ .ivu-table td {
    height: 48px;
  }

  /deep/ .ivu-tag {
    font-size: 11px;
    padding: 2px 4px;
    height: auto;
    line-height: 1.2;
  }

  /deep/ .ivu-table {
    font-size: 12px;
  }

  /deep/ .ivu-select-selection {
    height: 32px;
    line-height: 32px;
  }

  /deep/ .ivu-select-item {
    font-size: 12px;
    padding: 6px 12px;
  }
}

@media screen and (max-width: 480px) {
  .card-title {
    font-size: 15px;
  }

  .content-area {
    padding: 12px;
  }

  .table-wrapper {
    margin: 0 -8px;
    padding: 0 8px;
  }

  .content-title {
    font-size: 16px;
  }

  .boss-title {
    padding: 8px 0;
  }

  .boss-rank {
    width: 22px;
    height: 22px;
    font-size: 11px;
    margin-right: 8px;
  }

  .boss-name {
    font-size: 13px;
  }

  .equip-radio-group {
    gap: 4px;
  }

  .radio-item {
    min-width: 45px;
    font-size: 11px;
    padding: 3px 6px;
  }

  .tower-item {
    padding: 8px 6px;
  }

  .tower-rank {
    min-width: 22px;
    height: 22px;
    font-size: 11px;
    margin-right: 6px;
  }

  .tower-name,
  .tower-level {
    font-size: 12px;
  }

  .mobile-page {
    transform: scale(0.85);
  }

  /deep/ .ivu-table td {
    height: 44px;
  }

  /deep/ .ivu-table-cell {
    padding: 6px;
  }

  /deep/ .ivu-tag {
    font-size: 10px;
    padding: 1px 3px;
  }
}

/* 平板设备 */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .sidebar {
    width: 30%;
  }

  .content-area {
    width: 70%;
  }

  .menu-text {
    font-size: 13px;
  }

  .equip-radio-group {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 高亮自己行 */
/deep/ .ivu-table-row.my-row {
  background: #f0f9ff !important;
  font-weight: bold;
  color: #2d8cf0;
}
</style>

<style>
.ranking-container {
  background: #f5f9fc;
  border: 1px solid #c9dced;
  border-radius: 8px;
  overflow: hidden;
}
.ranking-container .mobile-warning {
  color: #6f8da6;
  background: #eef6fd;
  border-bottom: 1px solid #c9dced;
}
.ranking-container .layout-container {
  gap: 0;
  background: #f5f9fc;
}
.ranking-container .sidebar {
  width: 188px;
  min-width: 188px;
  padding: 12px 10px;
  background: #ffffff;
  border-right: 1px solid #c9dced;
  overflow-y: auto;
}
.ranking-nav-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 3px 8px 10px;
  color: #315a7c;
  border-bottom: 1px solid #e4eef5;
}
.ranking-nav-heading span { font-size: 13px; font-weight: 700; }
.ranking-nav-heading small { color: #8aa4b8; font-size: 10px; }
.ranking-nav-group { margin-top: 12px; }
.ranking-nav-group-title {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 8px 5px;
  color: #6f8da6;
  font-size: 10px;
  font-weight: 700;
}
.ranking-nav-group-title .ivu-icon { color: #5f96bf; font-size: 12px; }
.ranking-container .sidebar .menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 34px;
  margin: 2px 0;
  padding: 7px 8px;
  color: #426581;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;
}
.ranking-container .sidebar .menu-item .ivu-icon {
  min-width: 20px;
  margin-right: 7px;
  color: #86a7bf;
  font-size: 15px;
  text-align: center;
}
.ranking-container .sidebar .menu-item:hover {
  color: #315a7c;
  background: #f7fbff;
  border-color: #c9dced;
}
.ranking-container .sidebar .menu-item.active {
  color: #ffffff;
  background: #3978b7;
  border-color: #2f669d;
  box-shadow: 0 3px 8px rgba(57, 120, 183, .18);
}
.ranking-container .sidebar .menu-item.active .ivu-icon { color: #e8f4fc; }
.ranking-container .content-area {
  width: auto;
  flex: 1;
  padding: 16px 18px 20px;
  background: #f5f9fc;
}
.ranking-content-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #c9dced;
  border-radius: 6px;
}
.ranking-content-summary > div { display: grid; gap: 3px; }
.summary-kicker { color: #8aa4b8; font-size: 10px; }
.ranking-content-summary strong { color: #315a7c; font-size: 15px; }
.summary-tip { color: #7c98ac; font-size: 10px; }
.ranking-container .content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0;
  padding: 11px 14px;
  background: #ffffff;
  border: 1px solid #c9dced;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
}
.ranking-container .content-title { margin: 0; color: #315a7c; font-size: 16px; }
.ranking-container .equip-filter {
  padding: 10px;
  background: #f7fbff;
  border-color: #c9dced;
}
.ranking-container .boss-section,
.ranking-container .tower-list,
.ranking-container .table-wrapper {
  background: #ffffff;
  border-color: #c9dced;
  border-radius: 5px;
}
.ranking-container .content-header + .table-wrapper,
.ranking-container .content-header + .boss-section,
.ranking-container .content-header + .tower-list,
.ranking-container .content-header + .heaven-list-wrap {
  border: 1px solid #c9dced;
  border-top: 1px solid #e6eff5;
  border-radius: 0 0 6px 6px;
}
.heaven-list-wrap {
  position: relative;
  min-height: 120px;
  overflow: hidden;
  background: #ffffff;
}
.heaven-list {
  overflow-y: auto;
  border-top: 0;
}
.heaven-list-row {
  display: grid;
  grid-template-columns: 34px minmax(150px, 1.5fr) 80px minmax(120px, 1fr) 100px;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 8px 12px;
  background: #ffffff;
  border-bottom: 1px solid #e8eef6;
  transition: background .18s ease;
}
.heaven-list-row:last-child { border-bottom: 0; }
.heaven-list-row:hover { background: #f7faff; }
.heaven-list-row.my-row {
  background: #eef6fd;
  box-shadow: inset 3px 0 #3978b7;
}
.heaven-avatar {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: #2d8cf0;
  background: #edf5ff;
  border: 1px solid #cfe3fb;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
}
.heaven-avatar.ranking-rank--first {
  color: #ffffff;
  background: #d9574d;
  border-color: #b9443c;
}
.heaven-avatar.ranking-rank--top3 {
  color: #ffffff;
  background: #d9a441;
  border-color: #bd8927;
}
.heaven-avatar.ranking-rank--top10 {
  color: #ffffff;
  background: #8061b1;
  border-color: #684c96;
}
.heaven-avatar.ranking-rank--normal {
  color: #3978b7;
  background: #eef6fd;
  border-color: #cfe3fb;
}
.heaven-main,
.heaven-meta { min-width: 0; }
.heaven-main strong,
.heaven-main span,
.heaven-meta strong,
.heaven-meta span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.heaven-main strong {
  color: #17233d;
  font-size: 13px;
}
.heaven-main span,
.heaven-meta small {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: #808695;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.heaven-meta strong {
  color: #2d8cf0;
  font-size: 13px;
}
.heaven-meta span {
  color: #515a6e;
  font-size: 12px;
}
.heaven-rank { text-align: right; }
.heaven-list-state {
  padding: 36px 12px;
  color: #808695;
  text-align: center;
}
.ranking-title-badge {
  display: inline-block !important;
  max-width: 88px;
  padding: 2px 6px;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 10px !important;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ranking-title--first { color: #ffffff !important; background: #d9574d; border-color: #b9443c; }
.ranking-title--top3 { color: #ffffff !important; background: #d9a441; border-color: #bd8927; }
.ranking-title--top10 { color: #ffffff !important; background: #8061b1; border-color: #684c96; }
.ranking-title--normal { color: #6f8da6 !important; background: #f5f9fc; border-color: #dbe8f2; }
.ranking-container .boss-section { margin-bottom: 10px; padding: 8px; }
.ranking-container .boss-title { padding: 5px 3px 8px; }
.ranking-container .boss-name { color: #315a7c; }
.ranking-container .pagination-wrapper { padding-top: 12px; }
.ranking-panel { width: 100%; }
.ranking-container .table-wrapper {
  overflow-x: auto;
  padding: 0 10px;
}
.ranking-container .ivu-table-wrapper {
  border: 0;
  background: transparent;
}
.ranking-container .ivu-table,
.ranking-container .ivu-table:before,
.ranking-container .ivu-table:after {
  background: transparent;
  border: 0;
}
.ranking-container .ivu-table th {
  height: 34px;
  color: #7895aa;
  background: #f7fbff;
  border: 0;
  border-bottom: 1px solid #dbe8f2;
  font-size: 11px;
  font-weight: 700;
}
.ranking-container .ivu-table td {
  height: 48px;
  color: #426581;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #e6eff5;
}
.ranking-container .ivu-table tr:hover td,
.ranking-container .ivu-table-row-hover td {
  background: #f7fbff !important;
}
.ranking-container .ivu-table-cell {
  padding: 7px 10px;
  line-height: 1.35;
}
.ranking-container .ivu-table-row {
  transition: background .16s;
}
.ranking-container .ivu-table-row td:first-child {
  border-left: 3px solid transparent;
}
.ranking-container .ivu-table-row td:first-child .rank-cell {
  display: inline-grid;
  place-items: center;
  min-width: 26px;
  height: 26px;
  color: #6f8da6;
  background: #eef6fd;
  border-radius: 50%;
  font-size: 11px !important;
}
.ranking-container .name-cell,
.ranking-container .equip-cell,
.ranking-container .pet-cell,
.ranking-container .player-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.ranking-container .name-text,
.ranking-container .name-tag,
.ranking-container .player-cell > span {
  overflow: hidden;
  color: #315a7c;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ranking-container .rank-cell,
.ranking-container .level-cell,
.ranking-container .coin-cell,
.ranking-container .money-cell,
.ranking-container .damage-cell {
  color: #3978b7 !important;
  font-weight: 700;
}
.ranking-container .realm-cell { color: #6f8da6 !important; }
.ranking-container .ivu-table .ivu-tag {
  margin: 0;
  border-radius: 3px;
  font-size: 10px;
}
.ranking-container .ivu-table-row.my-row td {
  color: #315a7c;
  background: #eef6fd !important;
  font-weight: 700;
}
.ranking-container .ivu-table-row.my-row td:first-child {
  box-shadow: inset 3px 0 #3978b7;
}
.ranking-container .ivu-table-row.my-row td:first-child { border-left-color: #3978b7; }
.ranking-container .tower-item {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center;
  min-height: 52px;
  padding: 8px 12px;
  background: #ffffff;
  border-bottom: 1px solid #e6eff5;
}
.ranking-container .tower-item:last-child { border-bottom: 0; }
.ranking-container .tower-name { overflow: hidden; color: #315a7c; text-overflow: ellipsis; white-space: nowrap; }
.ranking-container .tower-level { color: #3978b7; font-weight: 700; }
@media screen and (max-width: 768px) {
  .ranking-container .layout-container { display: block; }
  .ranking-container .sidebar {
    display: flex;
    width: 100%;
    min-width: 0;
    padding: 8px;
    border-right: 0;
    border-bottom: 1px solid #c9dced;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
  }
  .ranking-container .sidebar::-webkit-scrollbar { display: none; }
  .ranking-nav-heading { display: none; }
  .ranking-nav-group {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 0 0 auto;
    margin: 0 8px 0 0;
    padding-right: 8px;
    border-right: 1px solid #e4eef5;
  }
  .ranking-nav-group:last-child { margin-right: 0; padding-right: 0; border-right: 0; }
  .ranking-nav-group-title { display: none; }
  .ranking-container .sidebar .menu-item {
    width: auto;
    min-height: 30px;
    margin: 0;
    padding: 6px 9px;
    white-space: nowrap;
  }
  .ranking-container .sidebar .menu-item .ivu-icon { display: none; }
  .ranking-container .content-area { padding: 12px 10px 16px; }
  .ranking-content-summary { margin-bottom: 10px; padding: 9px 10px; }
  .summary-tip { display: none; }
  .ranking-container .table-wrapper { padding: 0 4px; }
  .ranking-container .ivu-table-cell { padding: 6px 8px; }
  .heaven-list-row {
    grid-template-columns: 32px minmax(0, 1fr) 88px;
    gap: 8px;
    padding: 8px;
  }
  .heaven-level,
  .heaven-title { display: none; }
  .heaven-main span { font-size: 10px; }
  .ranking-title-badge { max-width: 82px; padding: 2px 4px; font-size: 9px !important; }
}
</style>



// WEBPACK FOOTER //
// src/components/rankingList.vue